import './contentElements/dynamicContent';
import {initModal, selectModal} from "./contentElements/openModal";
import {productSelect} from "./contentElements/productSelect"
import {checkboxHandler} from "./contentElements/checkboxHandler";
import {initTinyMce} from "./tinymce/tinymce";
import SelectContent from './plugins/selectContent';
import CustomDropzones from "./plugins/dropzone";
import Datatable from "./plugins/datatable";
import CustomSelects from "./form/selects";
import DefaultLoader from "./plugins/defaultLoader";
import ShowContent from "./plugins/showContent";
import TableSorter from "./plugins/tableSort";
import CustomClipboard from "./plugins/clipboard";
import Tinymce from "./tinymce/tinymce";
import AddTab from "./contentElements/tabs";
import {updateTranslationSelect} from "./contentElements/translation";

const defaultLoader = new DefaultLoader();

$(document).ready(function () {
    initModal();
    selectModal();
    productSelect();
    checkboxHandler();
    updateTranslationSelect();

    const selectContent = new SelectContent();

	const customDropzones = new CustomDropzones();
	customDropzones.initializeDefaultDropzones();

	const datatable = new Datatable();

	const customSelects = new CustomSelects();

	defaultLoader.initializeDefaultLoaders();

	const showContent = new ShowContent();

	const tableSorter = new TableSorter();

	const clipboard = new CustomClipboard();

	const tinymce = new Tinymce();

	const addTab = new AddTab();
});


$(window).on('load', function () {
	defaultLoader.removeAfterWindowLoad();
});




// WEBPACK FOOTER //
// ./resources/assets/js/app.js